// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGraphDataV2Schema } from './GraphDataV2Schema';
import type { IEstimationWithPriceInfoV2Schema } from './EstimationWithPriceInfoV2Schema';

export interface IOfferCardEstimationV3ResponseSchema {
  /** Доступные временные интервалы оценки **/
  estimationPeriods: EEstimationPeriods[];
  /** Графики изменения рыночной цены и оценки **/
  graphs: IGraphDataV2Schema[];
  /** Общая информация об оценке квартиры **/
  priceInfo?: IEstimationWithPriceInfoV2Schema;
}
export enum EEstimationPeriods {
  /** Для блока оценки за пол года **/
  'EstimatePeriodHalfYear' = 'estimatePeriodHalfYear',
  /** Для блока оценки за месяц **/
  'EstimatePeriodMonth' = 'estimatePeriodMonth',
  /** Для блока оценки за неделю **/
  'EstimatePeriodWeek' = 'estimatePeriodWeek',
}
